import { OverrideWindowFields } from './OverrideWindowFields';
import type { OverrideWindowGrain } from './overrideWindow';

export type PolicyOverrideWindowState = {
  startsAt: string;
  endsAt: string;
  reviewAt: string;
  setStartsAt: (value: string) => void;
  setEndsAt: (value: string) => void;
  setReviewAt: (value: string) => void;
  orderValid: boolean;
};

export function PolicyOverrideFormWindowFields({
  grain = 'day',
  window,
  pending,
}: {
  grain?: OverrideWindowGrain;
  window: PolicyOverrideWindowState;
  pending: boolean;
}) {
  return (
    <OverrideWindowFields
      grain={grain}
      startsAt={window.startsAt}
      endsAt={window.endsAt}
      reviewAt={window.reviewAt}
      onStartsAtChange={window.setStartsAt}
      onEndsAtChange={window.setEndsAt}
      onReviewAtChange={window.setReviewAt}
      orderInvalid={!window.orderValid}
      disabled={pending}
    />
  );
}
